import script from "./CrearTax.vue?vue&type=script&setup=true&lang=js"
export * from "./CrearTax.vue?vue&type=script&setup=true&lang=js"

import "./CrearTax.vue?vue&type=style&index=0&id=d798fa88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d798fa88"]])

export default __exports__